/*Since the map was loaded on client side, 
we need to make this component client rendered as well*/
"use client";

import {
  APIProvider,
  InfoWindow,
  Map,
  MapControl,
  Marker,
  useMapsLibrary
} from "@vis.gl/react-google-maps";
import { useEffect, useRef, useState } from "react";
import { Button } from "../ui/button";

const DEFAULT_MAPS = {
  lat: -6.2634008,
  lng: 106.7153196
};

const MapComponent = ({
  defaultLocation = DEFAULT_MAPS,
  handleCoordinates = () => {}
}) => {
  const [position, setPosition] = useState(defaultLocation);
  const [clickPusatkan, setClickPusatkan] = useState(false);

  useEffect(() => {
    handleCoordinates && handleCoordinates(position);
  }, [position]);

  const centerMapToCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        const newPosition = { lat: latitude, lng: longitude };
        setPosition(newPosition);
        setClickPusatkan(true);
      });
    }
  };

  const Kaka = () => {
    const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
    const inputRef = useRef(null);
    const places = useMapsLibrary("places");

    useEffect(() => {
      if (!places || !inputRef.current) return;

      const options = {
        fields: ["geometry"]
      };

      setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
    }, [places]);

    useEffect(() => {
      if (!placeAutocomplete) return;

      placeAutocomplete.addListener("place_changed", () => {
        // console.log("aaa", placeAutocomplete.getPlace()?.geometry?.location);
        setPosition({
          lat: placeAutocomplete.getPlace()?.geometry?.location?.lat(),
          lng: placeAutocomplete.getPlace()?.geometry?.location?.lng()
        });
        setClickPusatkan(true);
      });
    }, [position, placeAutocomplete]);

    return (
      <div className="flex flex-row items-center gap-4">
        <input
          ref={inputRef}
          className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring  disabled:cursor-not-allowed disabled:opacity-50"
        />
        <Button onClick={() => centerMapToCurrentLocation()}>Pusatkan</Button>
      </div>
    );
  };
  return (
    <APIProvider apiKey={process.env.GOOGLE_MAPS_API}>
      <Kaka />
      <Map
        style={{ width: "100%", height: "50vh" }}
        defaultCenter={position}
        center={clickPusatkan ? position : null}
        defaultZoom={17}
        onDrag={() => setClickPusatkan(false)}
        onMousemove={() => setClickPusatkan(false)}
        gestureHandling={"greedy"}
        disableDefaultUI={true}
        onClick={(a) => setPosition(a.detail.latLng)}
      >
        <Marker position={position} />
      </Map>
    </APIProvider>
  );
};

export { MapComponent };
